import { render, staticRenderFns } from "./ReportPremiumServices.vue?vue&type=template&id=6082346e&scoped=true"
import script from "./ReportPremiumServices.ts?vue&type=script&lang=ts&external"
export * from "./ReportPremiumServices.ts?vue&type=script&lang=ts&external"
import style0 from "./ReportPremiumServices.scss?vue&type=style&index=0&id=6082346e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6082346e",
  null
  
)

export default component.exports